import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { getLogoSvgOrUrl } from "../hot-tubs-ar/functions";
import { SwitchableContext, SwitchableProps } from "./context";

const MassageChairsIndex = ({ dataType }: SwitchableProps): JSX.Element => {
  return (
    <SwitchableContext.Provider value={{ dataType }}>
      <div className="brand3d-experiences-root">
        <header className="top-header">
          <nav className="top-nav">
            <ul className="top-menu">
              <li className={`menu-item`}>
                <NavLink
                  to={dataType === "chairs" ? "/massagechairs" : "/saunas"}
                >
                  <img
                    src={getLogoSvgOrUrl(dataType)}
                    alt="Company Logo"
                    className="company-logo"
                  />
                </NavLink>
              </li>
            </ul>
          </nav>
        </header>
        <main className="main-content">
          <Outlet />
        </main>
        <footer className="bottom-footer">
          <nav className="bottom-nav">
            <ul className="bottom-menu">
              <li>&copy;2024, Brand3D Inc. All rights reserved.</li>
            </ul>
          </nav>
        </footer>
      </div>
    </SwitchableContext.Provider>
  );
};

export default MassageChairsIndex;
